import { Ability } from '@casl/ability'
import { initialAbility } from './config'

// Ability is seeded with Auth rules; hydrated from persisted auth after store restore.
export default new Ability(initialAbility)
